import { isNotNil, isPlainObject } from '@flowio/is';
export function isSession(session) {
  var castSession = session;
  return isNotNil(castSession) && castSession.discriminator === 'organization_session' && isNotNil(castSession.id);
}
export function isErrorResponse(response) {
  var castError = response;
  return isPlainObject(castError.error) && Array.isArray(castError.error.messages);
}
//# sourceMappingURL=types.js.map